import Button from "ui/buttons/Button";
import Link from "ui/components/Link/Link";
import cx from "ui/cx";
import IconAddLarge from "ui/icons/IconAddLarge";
import styles from "./NewEntityButton.module.scss";

export interface NewEntityButtonProps extends React.HTMLAttributes<HTMLDivElement> {
  entityName: string;
  onClick?: () => unknown;
  linkUrl?: string;
  disabled?: boolean;
  disabledTooltipText?: string;
}

export default function NewEntityButton({
  entityName,
  onClick,
  linkUrl,
  disabled,
  disabledTooltipText,
  className,
  ...props
}: NewEntityButtonProps) {
  const buttonEl = (
    <Button
      btnStyle="primary"
      btnSize="large"
      disabled={disabled}
      title={disabledTooltipText}
      onClick={onClick}
      role="button"
    >
      <IconAddLarge />
      {`New ${entityName}`}
    </Button>
  );

  return (
    <div className={cx(styles.wrapper, className)} {...props}>
      {linkUrl ? (
        <Link href={linkUrl} disabled={disabled}>
          {buttonEl}
        </Link>
      ) : (
        buttonEl
      )}
    </div>
  );
}
